export default __webpack_public_path__ + "static/media/info.4891a175.svg";